import React, {Fragment} from "react";
import Ticker from "../components/Ticker";
import {LaneData} from "../components/LaneData";
import {PageLayout} from "../components/PageLayout";
import DragDrop from "../components/drag-drop";

const FileUploadProcessor = () => (
    <Fragment>
            <DragDrop></DragDrop>
    </Fragment>
);

export default FileUploadProcessor;
